module.exports = __webpack_public_path__ + "img/card-bg.c8dff878.png";